'use strict';

var AdvancedHepGridAddRowButtonDirective = function AdvancedHepGridAddRowButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/advanced-hep-grid-add-row-button.html'),
    controller: 'AdvancedHepGridAddRowButtonController'
  };
};
AdvancedHepGridAddRowButtonDirective.$inject = [];
module.exports = AdvancedHepGridAddRowButtonDirective;